import { compareOffers } from '../jobOfferComparator.js';

function formatCurrency(val) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(val);
}

function compare() {
    const getVal = (id) => parseFloat(document.getElementById(id).value) || 0;

    const offer1 = {
        salary: getVal('o1_salary'), bonus: getVal('o1_bonus'), ptoDays: getVal('o1_pto'),
        retirementMatch: getVal('o1_match'), commuteMiles: getVal('o1_commute')
    };
    const offer2 = {
        salary: getVal('o2_salary'), bonus: getVal('o2_bonus'), ptoDays: getVal('o2_pto'),
        retirementMatch: getVal('o2_match'), commuteMiles: getVal('o2_commute')
    };

    const result = compareOffers(offer1, offer2);

    const winnerDiv = document.getElementById('winner');
    const diff = Math.abs(result.difference);
    
    if (diff < 100) {
        winnerDiv.innerHTML = `<p style="font-size: 1.25rem; font-weight: 700; color: #6b7280;">The offers are practically identical!</p>`;
    } else {
        winnerDiv.innerHTML = `
            <p style="margin:0; font-size: 0.875rem; text-transform: uppercase; font-weight: 600; color: #6b7280;">Better Overall Offer</p>
            <p style="font-size: 1.5rem; font-weight: 800; color: #4f46e5;">Offer ${result.betterOffer}</p>
            <p style="margin: 0; font-weight: 500;">Advantage: ${formatCurrency(diff)} / year</p>
        `;
    }

    const buildTable = (o) => `
        <table class="comp-table">
            <tr><td>Base Salary</td><td>${formatCurrency(o.salary)}</td></tr>
            <tr><td>Annual Bonus</td><td>${formatCurrency(o.bonus)}</td></tr>
            <tr><td>PTO Value (${o.ptoDays} days)</td><td>${formatCurrency(o.ptoValue)}</td></tr>
            <tr><td>Retirement Match</td><td>${formatCurrency(o.retirementValue)}</td></tr>
            <tr><td>Commute Cost</td><td style="color: #dc2626;">- ${formatCurrency(o.annualCommuteCost)}</td></tr>
            <tr class="total-row"><td>Total Adjusted Comp</td><td>${formatCurrency(o.totalAdjustedComp)}</td></tr>
        </table>
    `;

    document.getElementById('results1').innerHTML = buildTable(result.offer1);
    document.getElementById('results2').innerHTML = buildTable(result.offer2);
}

document.getElementById('compareBtn').addEventListener('click', compare);
// Initial load
compare();
